import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import React from 'react';
import styles from './landing.module.scss';

// SEO
import SEO from '../../components/Common/SEO';
import { PAGE_SEO, STRUCTURED_DATA } from '../../config/seoConfig';
import { generateCanonicalUrl } from '../../utils/seoUtils';

// Components
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustedBy from './components/TrustedBy';
import FeatureCards from './components/FeatureCards';
import FeatureHighlight from './components/FeatureHighlight';
import HowItWorks from './components/HowItWorks';
import WhyChooseKeyQuest from './components/WhyChooseKeyQuest';
import FooterCTA from './components/FooterCTA';
import Footer from './components/Footer';

import PlansTable from './components/PlansTable';
import CaseStudies from './components/CaseStudies';
import TargetAudience from './components/TargetAudience';
import MidSectionCTA from './components/MidSectionCTA';

const LandingPage = () => {
      const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }, [location]);
  
    // SEO Configuration for landing page
    const seoConfig = PAGE_SEO.landing;
    const canonicalUrl = generateCanonicalUrl('/');
    
    return (
        <>
            <SEO
                title={seoConfig.title}
                description={seoConfig.description}
                keywords={seoConfig.keywords}
                canonical={canonicalUrl}
                robots={seoConfig.robots}
                structuredData={STRUCTURED_DATA.website}
                pageType="landing"
            />
            <div className={styles.landingPage}>
            <Navbar />
            <HeroSection />
            <TrustedBy />
            <div id="solutions">
                <TargetAudience />
            </div>

            {/* Feature Highlights Section Wrapper */}
            <div className={styles.featureHighlightsWrapper} id="features">
                <FeatureHighlight
                    title="Keyword & ASO Optimization for Meta Quest"
                    description="Simplify Your VR Journey"
                    imageSide="right"
                    features={[
                        "Keyword discovery and ranking analysis.",
                        "Keyword tracking for visibility improvement.",
                        "Recommendations for optimizing Meta game pages."
                    ]}
                    variant="pink"
                />

                <FeatureHighlight
                    title="Market Intelligence & Competitor Tracking"
                    description="Build with Powerful Tools"
                    imageSide="left"
                    features={[
                        "Track competitors’ performance (downloads, revenue, rankings).",
                        "Monitor trending apps, genres, and categories.",
                        "Identify emerging competitors and market shifts."
                    ]}
                    variant="blue"
                />

                <FeatureHighlight
                    title="Game & Portfolio Performance Tracking"
                    description="Portfolio tracking is easy with KeyQuest"
                    imageSide="right"
                    features={[
                        "Track the performance of your own games.",
                        "Create custom groups (genre, type, portfolio).",
                        "Receive alerts on ranking changes, reviews, and shifts in user sentiment."
                    ]}
                    variant="blue"
                />
            </div>

            <FeatureCards />

            <div id="how-it-works">
                <HowItWorks />
            </div>
            <MidSectionCTA />
            <WhyChooseKeyQuest />

            <div id="pricing">
                <PlansTable />
            </div>
            <div id="case-studies">
                <CaseStudies />
            </div>

            {/* <Testimonials /> */}
            <FooterCTA />
            <Footer />
        </div>
        </>
    );
};

export default LandingPage;
